import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "NY Pest & Exterminating | Eco-Friendly Pest Control NYC",
  description = "Professional eco-friendly pest control services in NYC. 24/7 service for rats, mice, bed bugs, termites & more. Serving all 5 boroughs. Licensed & insured. Call (646) 209-9955",
  keywords = "pest control NYC, exterminator New York, bed bugs NYC, rodent control, termite treatment, eco-friendly pest control, Brooklyn pest control, Manhattan exterminator, Queens pest control",
  ogImage = "https://nypestexterminating.com/og-image.jpg",
  url = "https://nypestexterminating.com"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="NY Pest & Exterminating" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Additional SEO Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="NY Pest & Exterminating" />
      <meta name="geo.region" content="US-NY" />
      <meta name="geo.placename" content="New York" />
      <meta name="geo.position" content="40.7128;-74.0060" />
      <meta name="ICBM" content="40.7128, -74.0060" />
      
      {/* Mobile Optimization */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#8FEC78" />
    </Helmet>
  );
};

export default SEOHead;
